module.exports = __webpack_public_path__ + "img/bubble-checkmark_fill.aca7aec4.svg";